import React, { Component } from 'react';
import { connect } from 'react-redux';
import { navigate } from '../modules/high_level_actions';

class Footer extends Component {

  constructor(props) {
    super(props);
    this.props.socialLinks[0].href = this.props.facebook_link;
    this.props.socialLinks[1].href = this.props.twitter_link;
  }

  render() {
    let { customer, tla, name } = this.props;
    const sFulfillmentType  = this.props.customer.fulfillment_type || '';
    const sStoreType        = this.props.storeType;
    let navLinksWrapper     = ''
    let msLink              = (!this.props.member_services_url) ? '' : (<li><a href="/member-services" onClick = {(evt) => this.props.dispatch(navigate(evt))} >Member Services</a></li>);
    let contactLink         = sStoreType === "Negative Option" ? (<li><a href="/contact-us" onClick = {(evt) => this.props.dispatch(navigate(evt))} >Contact Us</a></li>): '';
    let navLinks            = [];
    let trademark           = tla === 'DBC' ? 'Random House' : 'Bookspan';
    let copyright           = tla !== 'DVD' ?
      "Copyright © 2026 Bookspan. " + name + " ® is a registered trademark of "+ trademark + ". " :
      "©2026 Edge Line Ventures LLC. All rights reserved. " + name + " ® is a registered trademark used under license.";

    navLinks = (
      <ul>
        {msLink}
        { ['CRS','SFC'].includes(tla) ? '' : 
        <li><a href="/how-it-works" onClick = {(evt) => this.props.dispatch(navigate(evt))} >How It Works</a></li> }
        <li><a href="/terms-of-use" onClick = {(evt) => this.props.dispatch(navigate(evt))} >Terms of Use</a></li>
        <li><a href="/privacy-policy" onClick = {(evt) => this.props.dispatch(navigate(evt))} >Privacy Policy</a></li>
        <li><a href="/terms-of-membership" onClick = {(evt) => this.props.dispatch(navigate(evt))} >Terms of Membership</a></li>
        {contactLink}
      </ul>
    );

    navLinksWrapper = (
      <div className="footer-list-left">
        {navLinks}
      </div>
    );


    let socialLinks = this.props.socialLinks.map(function (oLink, index) {
      return (
        <li key={index}>
          <a href = {oLink.href}>{oLink.html}</a>
        </li>
      );
    }, this);

    return (
      <footer>
        <div className="content-max-width">
          {navLinksWrapper}
          <ul className="footer-list-right">
            {socialLinks}
          </ul>
          <p className="small-text">
            {copyright}
            <br />{tla === 'DBC' ? 'Used under license. ' : ''}Unauthorized use prohibited. All rights reserved.
          </p>
        </div>

      </footer>
    );
  }
};

Footer.defaultProps = {
  socialLinks: [
    {
      href: '',
      html: (
        <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
        width="40px" height="40px" viewBox="0 0 40 40" enable-background="new 0 0 40 40" >
          <path
          fill="#d1dadb"
          d="M0,0v40h40V0H0z M26.488,11.653l-2.352,0.001c-1.844,0-2.203,0.876-2.203,2.163v2.836h4.399l-0.572,4.443h-3.827v11.399
          h-4.585V21.098h-3.837v-4.444h3.837v-3.276c0-3.802,2.321-5.873,5.712-5.873c1.627,0,3.021,0.121,3.428,0.175V11.653z"/>
        </svg>
        )
    },
    {
      href: '',
      html: (
        <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg"  x="0px" y="0px"
        width="40px" height="40px" viewBox="0 0 40 40" enable-background="new 0 0 40 40">
          <path
          fill="#d1dadb"
          d="M0,0v40h40V0H0z M30.248,14.743c0.009,0.229,0.016,0.457,0.016,0.686c0,6.987-5.318,15.042-15.042,15.042
            c-2.987,0-5.767-0.875-8.106-2.373c0.413,0.047,0.834,0.072,1.26,0.072c2.479,0,4.758-0.844,6.566-2.262
            c-2.313-0.045-4.266-1.572-4.938-3.674c0.322,0.062,0.654,0.098,0.995,0.098c0.481,0,0.95-0.066,1.393-0.188
            c-2.417-0.486-4.241-2.624-4.241-5.186v-0.066c0.713,0.396,1.528,0.634,2.395,0.661c-1.418-0.947-2.352-2.567-2.352-4.4
            c0-0.969,0.261-1.877,0.716-2.659c2.608,3.201,6.504,5.305,10.898,5.525c-0.09-0.387-0.137-0.79-0.137-1.205
            c0-2.919,2.368-5.287,5.288-5.287c1.521,0,2.896,0.642,3.86,1.67c1.205-0.237,2.336-0.678,3.355-1.284
            c-0.395,1.235-1.232,2.271-2.324,2.925c1.068-0.128,2.088-0.412,3.036-0.833C32.176,13.068,31.279,13.999,30.248,14.743z"/>
        </svg>
      )
    }
  ]
};

function mapStateToProps(state){
    return {
      'name': state.store.name,
      'tla': state.store.tla,
      'facebook_link': state.store.facebook_link,
      'twitter_link': state.store.twitter_link,
      'customer': state.customer,
      'feedback': state.feedback,
      'member_services_url': state.store.member_services_url,
      'storeType': state.store.type
    };
}

export default connect(mapStateToProps)(Footer);



// WEBPACK FOOTER //
// ./src/components/Footer.jsx